import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {GroupItem} from 'devextreme-react/form';


export default class FormGroupItem extends Component {
    render() {
        return <GroupItem
            {...omit(['loading_state', 'setProps', 'children'], this.props)}
        >
            {this.props.children}
        </GroupItem>
    }
}

FormGroupItem.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,
    /**
     * A collection of an node's child elements
     */
    children: PropTypes.node,

    /**
     * Specifies whether or not all group item labels are aligned
     */
    alignItemLabels: PropTypes.bool,
    /**
     * Specifies the group caption
     */
    caption: PropTypes.string,
    /**
     * The count of columns in the group layout
     */
    colCount: PropTypes.number,
    /**
     * Specifies the relation between the screen size qualifier and the number of columns in the grouped layout
     */
    colCountByScreen: PropTypes.object,
    /**
     * Specifies the number of columns spanned by the item
     */
    colSpan: PropTypes.number,
    /**
     * An alias for the template property specified in React. Accepts a custom component.
     */
    component: PropTypes.object,
    /**
     * Specifies a CSS class to be applied to the form item
     */
    cssClass: PropTypes.string,
    /**
     * Holds an array of form items displayed within the group
     */
    items: PropTypes.arrayOf(PropTypes.object),
    /**
     * Specifies the item's type. Set it to "group" to create a group item.
     */
    itemType: PropTypes.oneOf(['empty', 'group', 'simple', 'tabbed', 'button']),
    /**
     * Specifies a name that identifies the form item
     */
    name: PropTypes.string,
    /**
     * An alias for the template property specified in React. Accepts a rendering function.
     */
    render: PropTypes.func,
    /**
     * A template that can be used to replace the default editor with custom content
     */
    template: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * Specifies whether or not the current form item is visible
     */
    visible: PropTypes.bool,
    /**
     * Specifies the sequence number of the item in a form, group or tab
     */
    visibleIndex: PropTypes.number,

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

FormGroupItem.defaultProps = {
    alignItemLabels: true,
    // caption: undefined,
    colCount: 1,
    // colCountByScreen: undefined,
    // colSpan: undefined,
    // component:
    // cssClass: undefined,
    // items: undefined,
    itemType: 'simple',
    // name: undefined,
    // render: undefined,
    // template: undefined,
    visible: true,
    // visibleIndex: undefined
};
